import React from 'react'

function ResentInvitations({
        alreadySentEmailsList,
        handleRemoveResendEmail,
        handleCloseResendModal,
        handleResendEmails,
        isMailLoading,
        roleId,
        crssrImage,
        dletImage
}) {
        return (
                <>
                        <div className="modal">
                                <div className="modal-close-invite outter-modal-main">
                                        <a
                                                className=""
                                                onClick={isMailLoading ? undefined : handleCloseResendModal}
                                                style={{
                                                        pointerEvents: isMailLoading ? "none" : "auto",
                                                        cursor: isMailLoading ? "not-allowed" : "pointer",
                                                        opacity: isMailLoading ? 0.6 : 1,
                                                }}
                                        >
                                                <img src={crssrImage} alt="Edit Icon" />{" "}
                                        </a>
                                </div>
                                <div className="modal-invite-head">
                                        <h2 className="">Resend Invitations</h2>
                                </div>
                                {/* List the already sent emails here */}
                                <div>
                                        <div className="the-modal-inuser">
                                                <label htmlFor="grid-password" className="">
                                                        Email
                                                </label>
                                                {alreadySentEmailsList.map((email) => (
                                                        <div key={email.email} className="the-modal-inusers">
                                                                <div className="resend-invitation">
                                                                        <input
                                                                                type="email"
                                                                                className=""
                                                                                name="email"
                                                                                required
                                                                                placeholder="Enter Email ID"
                                                                                value={email.email}
                                                                                disabled
                                                                        />
                                                                        <label
                                                                                htmlFor="grid-password"
                                                                                className="type-of-acc"
                                                                        >
                                                                                Role
                                                                        </label>
                                                                        <select value={email.userType} disabled>
                                                                                <option value="">Select Role</option>
                                                                                {roleId.map((role) => (
                                                                                        <option key={role._id} value={role._id}>
                                                                                                {role.user_type}
                                                                                        </option>
                                                                                ))}
                                                                        </select>
                                                                        {alreadySentEmailsList.length > 1 && (
                                                                                <button
                                                                                        className="del-resend"
                                                                                        onClick={() => handleRemoveResendEmail(email)}
                                                                                >
                                                                                        <img src={dletImage} alt="delete-icon" />{" "}
                                                                                </button>
                                                                        )}
                                                                </div>
                                                        </div>
                                                ))}
                                        </div>
                                </div>
                                <div className="sprint-btn-outer resend-invoice">
                                        <button
                                                type="button"
                                                onClick={isMailLoading ? undefined : handleCloseResendModal}
                                                disabled={isMailLoading}
                                                className="submit-client cancel-sprint"
                                                style={{
                                                        pointerEvents: isMailLoading ? "none" : "auto",
                                                        cursor: isMailLoading ? "not-allowed" : "pointer",
                                                        opacity: isMailLoading ? 0.6 : 1,
                                                }}
                                        >
                                                Cancel
                                        </button>
                                        {isMailLoading ? (
                                                <div
                                                        style={{
                                                                minWidth: "160px",
                                                                height: "44px",
                                                                backgroundColor: "#e5e7eb",
                                                                border: "1px solid rgba(106, 121, 136, 0.3)",
                                                                borderRadius: "6px",
                                                                animation: "pulse 1.5s ease-in-out infinite",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                boxSizing: "border-box",
                                                        }}
                                                >
                                                        <div
                                                                style={{
                                                                        width: "130px",
                                                                        height: "18px",
                                                                        backgroundColor: "rgba(255, 255, 255, 0.6)",
                                                                        borderRadius: "4px",
                                                                        animation: "pulse 1.5s ease-in-out infinite",
                                                                }}
                                                        />
                                                </div>
                                        ) : (
                                                <button
                                                        type="button"
                                                        className="submit-client save-sprint"
                                                        disabled={isMailLoading}
                                                        onClick={handleResendEmails}
                                                >
                                                        Resend Invitations
                                                </button>
                                        )}
                                </div>
                        </div>
                        <style>{`
                        @keyframes pulse {
                                0%, 100% {
                                        opacity: 1;
                                }
                                50% {
                                        opacity: 0.5;
                                }
                        }
                `}</style>
                </>
        )
}

export default ResentInvitations